// extracted by mini-css-extract-plugin
export default {"fail_container":"failedverification_fail_container__iKEno"};